import tisPop from './tisPop.vue';
export default tisPop;
